 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		61: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "novo-" + ({"0":"common","2":"artsy-common","3":"ConversationApp~Routes-Conversation","4":"Routes-Overview~Routes-Works","6":"ArtistApp","7":"ArtistSeriesApp","8":"ArtistsApp","9":"ArtworkApp","10":"AuctionsApp","11":"ConversationApp","12":"Error","13":"FairApp","14":"FairSubApp","15":"FairsApp","16":"FeatureApp","17":"IdentityVerificationApp","18":"OrderApp","19":"PartnerApp","20":"Processing","21":"PurchaseApp","22":"Routes-Articles","23":"Routes-Artists","24":"Routes-ArtistsByLetter","25":"Routes-ArtistsIndex","26":"Routes-AuctionResults","27":"Routes-CV","28":"Routes-Collect","29":"Routes-Collection","30":"Routes-Collections","31":"Routes-Consign","32":"Routes-Contact","33":"Routes-Conversation","34":"Routes-CurrentAuctions","35":"Routes-Example-ExampleApp","36":"Routes-ExampleArtist-ExampleArtistApp","37":"Routes-ExampleArtwork-ExampleArtworkApp","38":"Routes-FairArticles","39":"Routes-FairArtworks","40":"Routes-FairExhibitors","41":"Routes-FairInfo","42":"Routes-FairsIndex","43":"Routes-MarketingLanding-MarketingLandingApp","44":"Routes-Offer-OfferDetailApp","45":"Routes-Overview","46":"Routes-PastAuctions","47":"Routes-Payment-PaymentApp","48":"Routes-ShowInfo","49":"Routes-Shows","50":"Routes-UpcomingAuctions","51":"Routes-Works","52":"ShowApp","53":"ShowSubApp","54":"ViewingRoomApp","55":"ViewingRoomsApp","57":"buildClientApp","59":"initModalManager","60":"legacy-assets-dll","62":"setupArtistSignUpModal"}[chunkId]||chunkId) + ".22820." + {"0":"30421f16db901f8ed2a4","2":"5e0d7677f31e4f2fbcbb","3":"9455b70054b38372c106","4":"58d44505bed852ccd5fe","6":"50b76fe43f80a3b78510","7":"bf99cf63ca9a24c0efd0","8":"939ee421fd84fd099e67","9":"ab7fdaa5d02230175bb3","10":"6854c8e7337c2706e35a","11":"052565e5766a33b70cc8","12":"c49df20ed98059f867f1","13":"6db3fc52ac0c499b6445","14":"ac3dc29d76c82ccc326d","15":"92982686c8b39a081a76","16":"280b7740433c8f0efeeb","17":"381126bc87989d2cae44","18":"f8492999fe46c4f33dbc","19":"5c2e07d6dcba671f4fee","20":"4f7e4f2e4eb26986b192","21":"e353201f5cb11460cca6","22":"55a9b597e1c673751087","23":"5cafa161c1ec184a61bd","24":"2ebcf7fa52c192273e7d","25":"75cdbb4bae81d02a6df4","26":"1552f23e0a3f5ef76d0f","27":"6a62e52ebc5c1a814d4a","28":"9a1f1fda0b219bd14fec","29":"6b6cf7e1fa6403121856","30":"3986b52d7771022185b8","31":"a841fa29ace19a49881a","32":"b50f2c69e39e57f7ee85","33":"42320d482df959ce23b4","34":"fbb4541b37ce5b4b7d6f","35":"7776501518594a7a67cc","36":"507f4ea528074c398869","37":"356c52ece375be379103","38":"a148dee0bfe2f593653b","39":"1aea679d2e82f4b8a24e","40":"da50e85040b5e18251f7","41":"8905d524d3b202895c49","42":"a95063c582538f709064","43":"603c545af6ffd165ed22","44":"97e7525a842cb0971cc7","45":"b4cfb75aaf21c0e8382c","46":"500ff48213cf8bdba56e","47":"21f193530823a27ca787","48":"0fc37c5653d68087d378","49":"68e36f0ba3650554ead8","50":"882bd7ae3ac0d8eedf0b","51":"7414266b886b7e998aa5","52":"0a99225a06d0c316c417","53":"46718c1f479edc8dc54a","54":"e02b0cbd281df9a8908d","55":"e91b372e2c969836a054","57":"095a4f778ea5b6a7f2d2","59":"380817dba7a848fa45f5","60":"e956c44908d789d1f842","62":"d0e504ceaa36cd3c0a42"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				function loadScript(src, retries) {
 				  var script = document.createElement('script');
 				  var retryAttempt = 5 - retries + 1;
 				  var retryAttemptString = '&retry-attempt=' + retryAttempt;
 				  var onScriptComplete;

 				  script.charset = 'utf-8';
 				  script.timeout = 120;
 				  if (__webpack_require__.nc) {
 				    script.setAttribute('nonce', __webpack_require__.nc);
 				  }
 				  script.src = src;

 				  onScriptComplete = function(event) {
 				    // avoid mem leaks in IE.
 				    script.onerror = script.onload = null;
 				    clearTimeout(timeout);
 				    var chunk = installedChunks[chunkId];
 				    if (chunk !== 0) {
 				      if (chunk) {
 				        if (retries === 0) {
 				          var errorType =
 				            event && (event.type === 'load' ? 'missing' : event.type);
 				          var realSrc = event && event.target && event.target.src;
 				          error.message =
 				            'Loading chunk ' +
 				            chunkId +
 				            ' failed.\n(' +
 				            errorType +
 				            ': ' +
 				            realSrc +
 				            ')';
 				          error.name = 'ChunkLoadError';
 				          error.type = errorType;
 				          error.request = realSrc;
 				          chunk[1](error);
 				          installedChunks[chunkId] = undefined;
 				        } else {
 				          var cacheBust = (function() {
 				            return 'cache-bust=' + Date.now();
 				          })();
 				          +retryAttemptString;
 				          var retryScript = loadScript(
 				            jsonpScriptSrc(chunkId) + '?' + cacheBust,
 				            retries - 1
 				          );
 				          document.head.appendChild(retryScript);
 				        }
 				      } else {
 				        installedChunks[chunkId] = undefined;
 				      }
 				    }
 				  };
 				  var timeout = setTimeout(function() {
 				    onScriptComplete({ type: 'timeout', target: script });
 				  }, 120000);
 				  script.onerror = script.onload = onScriptComplete;
 				  return script;
 				}

 				var script = loadScript(jsonpScriptSrc(chunkId), 5);
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets-novo/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
